import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { useToggle } from 'usehooks-ts'

import type { IconName } from '@fv/client-components'

import { AdminSliderPanel } from '@/components/AdminSliderPanel'
import { AdminButton } from '@/components/shared/AdminButton'
import { AdminCode } from '@/components/shared/AdminCode'
import { QuerySuspense } from '@/components/shared/AdminLoading'
import { adminFetch } from '@/utils'

type Props = {
  buttonText: string
  buttonTooltip?: string
  buttonIcon?: IconName
  url: string
}
export const AdminRawResponsePanel = ({
  buttonText,
  buttonTooltip,
  buttonIcon,
  url,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [showPanel, togglePanel] = useToggle()
  const [data, setData] = useState<unknown>(null)

  const handleClose = () => {
    togglePanel()
    setData(null)
  }

  useEffect(() => {
    ;(async () => {
      if (!data && showPanel) {
        setIsLoading(true)
        try {
          setData(await adminFetch(url))
        } catch (e) {
          toast.error('Unable to fetch data')
        }
        setIsLoading(false)
      }
    })()
  }, [showPanel, data, url])

  return (
    <>
      <AdminButton
        className="btn-sm"
        onClick={togglePanel}
        icon={buttonIcon}
        tooltip={buttonTooltip}
      >
        {buttonText}
      </AdminButton>
      <AdminSliderPanel isOpen={showPanel} onClose={handleClose}>
        <QuerySuspense query={{ isLoading }}>
          <AdminCode data={data} />
        </QuerySuspense>
      </AdminSliderPanel>
    </>
  )
}
